module.exports = __webpack_public_path__ + "static/media/agile_advantage.0b98572f.png";